import { render } from "./NoRackLot.vue?vue&type=template&id=2aa2f920"
import script from "./NoRackLot.vue?vue&type=script&lang=js"
export * from "./NoRackLot.vue?vue&type=script&lang=js"
script.render = render

export default script